import {runInAction} from "mobx";
import {
  getBoatCategories,
  getBoatClasses,
  getBoatTypes,
  TDictionary
} from "@ui/api/user"
import store from "./";

export interface IDictionary {
	readonly boatClasses: TDictionary[]
	readonly boatTypes: TDictionary[]
  readonly boatCategories: TDictionary[]

	init(): void
	boatClassDesc(code?: string | null): string | undefined | null
	boatTypesDesc(code?: string | null): string | undefined | null
  boatCategoriesDesc(code?: string | null): string | undefined | null
}

export class Dictionary implements IDictionary {
	boatClasses: TDictionary[] = []
	boatTypes: TDictionary[] = []
  boatCategories: TDictionary[] = []

	init() {
		const {debug} = store
		getBoatClasses()
			.then(data => runInAction(() => this.boatClasses = data))
			.catch(error => debug.error(`Dictionary::getBoatClasses::error: ${error.code}, ${error.message}`))
		getBoatTypes()
			.then(data => runInAction(() => this.boatTypes = data))
			.catch(error => debug.error(`Dictionary::getBoatTypes::error: ${error.code}, ${error.message}`))
    getBoatCategories()
      .then(data => runInAction(() => this.boatCategories = data))
			.catch(error => debug.error(`Dictionary::getBoatCategories::error: ${error.code}, ${error.message}`))
	}

	boatClassDesc(code?: string | null) {
		return this.boatClasses.find(clazz => clazz.code === code)?.desc
	}

	boatTypesDesc(code?: string | null) {
		return this.boatTypes.find(type => type.code === code)?.desc
	}

  boatCategoriesDesc(code?: string | null) {
		return this.boatCategories.find(type => type.code === code)?.desc
	}
}
